var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSonusvos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 195 195",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-271.493,-655.817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.667,766.778L366.667,731.035C366.668,729.058 368.077,727.34 370.017,726.953L382.514,724.453C382.783,724.4 383.056,724.373 383.331,724.373C385.615,724.373 387.495,726.251 387.496,728.536L387.496,735.951L370.833,739.284L370.833,773.443C370.833,778.047 366.167,781.775 360.418,781.775C354.67,781.775 350.004,778.047 350.004,773.443C350.004,768.84 354.67,765.112 360.418,765.112C362.762,765.112 364.926,765.731 366.667,766.778Z",
    style: {
      fill: "rgb(255,102,102)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-271.493,-655.817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.224,717.316C472.299,750.504 466.579,789.703 441.149,818.042C405.293,858 343.741,861.33 303.782,825.473C263.824,789.616 260.494,728.064 296.351,688.106C330.529,650.018 388.055,645.21 427.975,675.901C427.411,678.349 427.114,680.897 427.114,683.515C427.114,701.612 441.348,716.41 459.224,717.316ZM368.75,681.79C329.408,681.79 297.466,713.731 297.466,753.074C297.466,792.416 329.408,824.357 368.75,824.357C408.093,824.357 440.034,792.416 440.034,753.074C440.034,713.731 408.093,681.79 368.75,681.79Z",
    style: {
      fill: "rgb(255,102,102)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.951848,0,0,0.951848,-261.249,-620.777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.642,687.864C413.341,687.864 443.135,717.659 443.135,754.357C443.135,791.056 413.341,820.85 376.642,820.85C339.944,820.85 310.149,791.056 310.149,754.357C310.149,717.659 339.944,687.864 376.642,687.864ZM376.642,707.853C402.309,707.853 423.147,728.691 423.147,754.357C423.147,780.024 402.309,800.862 376.642,800.862C350.976,800.862 330.138,780.024 330.138,754.357C330.138,728.691 350.976,707.853 376.642,707.853Z",
    style: {
      fill: "rgb(255,102,102)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonusvos);
export default __webpack_public_path__ + "static/media/sonusvos.48def4503cd6d0366b22e823afb1234e.svg";
export { ForwardRef as ReactComponent };